import "./style.scss";

import Button, { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { FC, useEffect, useState } from "react";

import Checkbox from "shared/ui/Checkbox/Checkbox";
import { DocumentUnion } from "shared/types/types";
import EmptyContent from "../EmptyContent";
import { ReactComponent as IconNext } from "../../assets/img/icons/icon_carret-Right.svg";
import { ReactComponent as IconPrev } from "../../assets/img/icons/icon_carret-Left.svg";
import { ReactComponent as Lock } from "../../assets/img/icons/icon_Lock.svg";
import { ReactComponent as IconCLockSmall } from "../../assets/img/icons/icon_clock_small.svg";
import NationalityBadge from "../NationalityBadge";
import React from "react";
import ToggleIdNumber from "../ToggleIdNumber/ToggleIdNumber";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { formatDocumentType, joursRestants, remainDate } from "../../utils/utils";
import { parseFormatDateIDProtect } from "shared/lib/date_utils";

type TableColumn = {
    key: string;
    label: string;
};

type TableProps = {
    columns: TableColumn[];
    rows: DocumentUnion[];
    selectable?: boolean;
    onSelectionChange: (selectedRows: DocumentUnion[]) => void;
    selectedRows: DocumentUnion[];
    editable?: boolean;
    size?: string;
    className?: string;
    isClickable?: boolean;
    fixStatusToPerte?: boolean;
    hideDocType?: boolean;
};

const ITEMS_PER_PAGE = 10;

const Table: FC<TableProps> = ({
   columns,
   rows, selectedRows,
   selectable = false,
   onSelectionChange,
   editable,
   size,
   className,
   isClickable = true,
    fixStatusToPerte = false,
  hideDocType = false
}) => {
    const navigate = useNavigate();
    const [selectAll, setSelectAll] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(rows.length / ITEMS_PER_PAGE);

    // Get rows for the current page
    const getVisibleRows = () => {
        const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
        const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, rows.length);
        return rows.slice(startIndex, endIndex);
    };

    useEffect(() => {
        if (onSelectionChange) {
            onSelectionChange(selectedRows);
        }
        // set selectedRows to empty array when no rows are selected
        if (selectedRows.length === 0) {
            setSelectAll(false);
        }
    }, [selectedRows, rows]);

    useEffect(() => {
        if (onSelectionChange) {
            onSelectionChange(selectedRows);
        }
    }, [selectedRows, rows]);

    // Fonction pour formater les données en fonction de leur clé
    const formatData = (key: string, data: any, id: number, document?: any) => {

        switch (key) {
            case "nationality":
                return (
                    <div onClick={() => handleDocumentClick(id)} className={"pointer"}>
                        <NationalityBadge nationality={data} />
                    </div>
                );
            case "type":
                return (
                    <div
                        className="td--type pointer"
                        onClick={() => handleDocumentClick(id)}>
                        {formatDocumentType(data)}
                    </div>
                );
            case "number":
                return (
                    <div className="d-flex justify-content-center align-items-start w-100 flex-column">
                        {/*<p className={"text-dark text-xs text-ellipsis w-32"}>{`${document?.prenom ?? ''} ${document?.nom ?? ''}`}</p>*/}
                        <ToggleIdNumber number={data} />
                    </div>
                );
            case "dateExpiration":
                return (
                    <div
                      className={"pointer"}
                        onClick={() => handleDocumentClick(id)}>
                        <span className={"text-xs d-flex flex-row text-muted-foreground"}>
                            <span className={'bold'}>EXP</span> : {parseFormatDateIDProtect(data)}
                        </span>
                    </div>
                );

            case "createdAt":
                return (
                  <div
                    className={"pointer"}
                    onClick={() => handleDocumentClick(id)}>
                        <span className={"text-xs d-flex flex-row text-muted-foreground"}>
                            <span className={'bold'}>AJouté le </span> : {parseFormatDateIDProtect(data)}
                        </span>
                  </div>
                );

            case "status":
                return (
                    <span
                        className={`tag ${data === "SUIVI" ? "tag-success" : "tag-error"} text-center pointer`}
                        onClick={() => handleDocumentClick(id)}>
                        {!fixStatusToPerte ? data : 'perte'}
                    </span>
                );

            case "remainDateExp":
                return (
                  <span
                    className={`bg-error-70 text-error-40 rounded-lg text-center gap-05 d-flex flex-wrap justify-content-center align-items-center py-2 px-3`}
                   >
                       <span>
                           <IconCLockSmall width={12}/>
                       </span>
                      <span>{`${joursRestants(document?.dateExpiration)?.message ?? ''}`}</span>
                    </span>
                );
            case "isBlocked":
                return (
                    <div
                        className="td--isBlocked pointer"
                        onClick={() => handleDocumentClick(id)}>
                        {data ? (
                            <Lock
                                fill="#9FC1EF"
                                width={12}
                            />
                        ) : (
                            ""
                        )}
                    </div>
                );
            default:
                return data;
        }
    };

    const handleRowSelect = (document: DocumentUnion, checked: boolean) => {
        const { id } = document;
        if (selectable) {
            let newSelectedRows: DocumentUnion[] = [];
            if (checked) {
                newSelectedRows = [...selectedRows, document];
            } else {
                newSelectedRows = selectedRows.filter((row) => row.id !== id);
            }
            onSelectionChange(newSelectedRows);
        }
    };

    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);
        // Si newSelectAll est true, sélectionnez toutes les lignes, sinon videz les sélections
        onSelectionChange(newSelectAll ? rows : []);
    };

    const handleDocumentClick = (id: number) => {
        if (isClickable) {
            navigate(`/mes-documents/${id.toString()}`);
        }
    };

    const goToPreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const goToNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    return (
        <>
            {rows.length > 0 ? (
                <table className={`table table--${selectable && "selectable"} ${className && className} ${size && "table--" + size}`}>
                    {editable && (
                        <thead>
                            <tr>
                                {selectable && (
                                    <th>
                                        <Checkbox
                                            onChange={() => handleSelectAll()}
                                            checked={selectAll}
                                        />
                                    </th>
                                )}
                                {columns.map((column) => (
                                    <th
                                        key={column.key}
                                        className={column.key === "creationDate" ? "text-center" : ""}>
                                        {column.label}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                    )}
                    <tbody>
                        <tr>
                            <td
                                colSpan={columns.length}
                                style={{ height: 10, opacity: 0 }}
                            />
                        </tr>
                        {getVisibleRows().map((row: DocumentUnion, index: number) => (
                            // Utilisation de la fragment React pour regrouper les éléments
                            <React.Fragment key={index}>
                                <tr className={`hover:shadow ${isClickable ? '': "cursor-default"}`}>
                                    {selectable && (
                                        <td className={"pointer"}>
                                            <Checkbox
                                                onChange={(e) => {
                                                    handleRowSelect(row, e.target.checked);
                                                }}
                                                checked={selectedRows.includes(row)}
                                            />
                                        </td>
                                    )}
                                    {columns.map((column: TableColumn) => (
                                        <td
                                          key={column.key}
                                          className={"text-sm"}
                                          data-label={column.label}
                                        >
                                            {formatData(column.key, row[column.key as keyof DocumentUnion], row.id, row)}
                                        </td>
                                    ))}
                                </tr>

                                <tr>
                                    <td
                                        colSpan={columns.length}
                                        style={{ height: 10, opacity: 0 }}
                                    />
                                </tr>
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            ) : (
                <EmptyContent text="Vous n'avez aucun document enregistrés" />
            )}
            {totalPages > 1 && (
                <div className="pagination">
                    <Button
                        onClick={goToPreviousPage}
                        disabled={currentPage === 1}
                        icon={<IconPrev fill="#1956A8" />}
                        style={Button_Style.OUTLINED}
                        type={Button_Type.PRIMARY}
                    />
                    <Button
                        onClick={goToNextPage}
                        disabled={currentPage === totalPages}
                        icon={<IconNext fill="#1956A8" />}
                        style={Button_Style.OUTLINED}
                        type={Button_Type.PRIMARY}
                        isIconButton
                    />
                    <span>
                        Page {currentPage} sur {totalPages}
                    </span>
                </div>
            )}
        </>
    );
};

export default Table;
